module.exports = __webpack_public_path__ + "static/media/main_background.bb03b4e0.png";